export default __webpack_public_path__ + "static/decoratorSevenSecond-f0f132840c0481d04503719fd439db72.png";